import validate from "/vercel/path0/node_modules/.pnpm/nuxt@3.7.4_eslint@8.51.0_typescript@5.2.2/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/vercel/path0/apps/dash/middleware/auth.global.ts";
export const globalMiddleware = [
  validate,
  auth_45global
]
export const namedMiddleware = {
  authadminonly: () => import("/vercel/path0/apps/dash/middleware/authadminonly.ts"),
  authcheck: () => import("/vercel/path0/apps/dash/middleware/authcheck.ts")
}